import LoadingConstants from 'app/shared/constants/LoadingConstants';
import DispatchConstants from 'app/shared/constants/DispatchConstants';

const initState = () => ({
    loadingState: LoadingConstants.INITIAL,
    paymentMethods: [],
    userHasPaymentMethods: false,
    accountSettings: [],
});

const paymentMethods = (state = initState(), action = {}) => {
    const { type, payload } = action;
    switch (type) {
        case DispatchConstants.BILLING_PAYMENT_METHODS_INIT:
            return initState();
        case DispatchConstants.BILLING_PAYMENT_METHODS_SET_LOADING_STATE:
            return {
                ...state,
                loadingState: payload,
            };
        case DispatchConstants.BILLING_PAYMENT_METHODS_SET_ACCOUNT_SETTINGS:
            return {
                ...state,
                accountSettings: payload,
            };
        case DispatchConstants.BILLING_PAYMENT_METHODS_SET_PAYMENT_METHODS:
            return {
                ...state,
                loadingState: LoadingConstants.SUCCESS,
                paymentMethods: payload,
            };
        case DispatchConstants.BILLING_PAYMENT_SET_USER_HAS_METHODS:
            return {
                ...state,
                userHasPaymentMethods: payload,
            };
        default:
            return state;
    }
};

export default paymentMethods;
